export const main = {
    hisTimeTable: "<name>{{name}}</name><space/><normal>'s Timetable</normal>",
    schedule: {
        title: "Due to {{content}}",
        link: "Go to Student Portal",
        contents: {
            beginning: "Beginning",
            end: "End",
            courseRegistrationPeriodStart: "Start of Course Registration Period",
            courseRegistrationPeriodEnd: "End of Course Registration Period",
            courseAddDropPeriodEnd: "End of Course Add & Drop Period",
            courseDropDeadline: "Deadline to Course Drop",
            courseEvaluationDeadline: "Deadline to Course Evaluation",
            gradePosting: "Grade Posting",
        },
    },
    reviewSection: {
        title: "How did you find the {{lectureName}} course?",
        placeholder:
            "How did you find the gradings and workload — fair, heavy, or just right?",
        writeAnother: "Another one",
    },
    recentFeed: {
        title: "<bold>Fresh</bold><space/><normal>Reviews</normal>",
    },
    likedMajorFeed: {
        title: "<bold>Popular</bold><space/><normal>Reviews</normal>",
    },
    hallOfFameFeed: {
        title: "<bold>Hall of</bold><space/><normal>Fame</normal>",
    },
    scheduleFeed: {
        title: "School Schedules",
        noSchedules: "No schedules",
    },
}
